import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import './styles.css';


const Login = ({ onLogin, isAuthenticating }) => {
  const handleLogin = () => {
    onLogin();
  };

  if (isAuthenticating) {
    return (
      <Box className="login-box">
        <div className="login-container">
          <p className="popup-description" id="popup-description">
            Register Your GM Energy Product
          </p>
          <p className="popup-message">
            Authenticating, please wait&hellip;
          </p>
          <div className="login-button">
            <CircularProgress size={32} sx={{ color: '#000' }} />
          </div>
        </div>
      </Box>
    );
  }

  return (
    <Box className="login-box">
    <div className= "login-container">
      <p className="popup-description" id="popup-description">
        Register Your GM Energy Product
      </p>
      <p className="popup-message" id="popip-message">
      Please log in or sign up with the GM account you want to use for your GM Energy product registration.
      </p>
      <div className="login-button">
        <Button
          variant="contained"
          color="primary"
          onClick={handleLogin}
          sx={{backgroundColor: '#000', '&:hover': { backgroundColor: '#0009FF' } }}
        >
          Log in / Sign up
        </Button>
      </div>
    </div>
    </Box>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
  isAuthenticating: PropTypes.bool,
};

export default Login;